import ListBox from "../base/ListBox.js";
import PlainListBoxMixin from "./PlainListBoxMixin.js";

/**
 * ListBox component in the Plain reference design system
 *
 * @inherits ListBox
 */
class PlainListBox extends PlainListBoxMixin(ListBox) {}

export default PlainListBox;
